import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../service/axiosInstanceNode";

export const uploadScoutingReport = createAsyncThunk(
  "scoutingReports/upload",
  async ({ scoutingReport, token, signal }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("scoutingReport", scoutingReport);

      const response = await axiosInstance.post(
        "/scouting-reports/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: signal, // Add abort signal for cancellation
        }
      );
      return response.data;
    } catch (error) {
      // Check if the error is due to cancellation
      if (error.name === 'CanceledError' || error.message === 'canceled') {
        return rejectWithValue('Request was cancelled');
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAllReport = createAsyncThunk(
  "scoutingReports/getAllReports",
  async ({ token, search }, { rejectWithValue }) => {
    try {
      const params = search ? { params: { search } } : {};
      const response = await axiosInstance.get("/scouting-reports", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...params,
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getReportById = createAsyncThunk(
  "scoutingReports/getReportById",
  async ({ token, id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/scouting-reports/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateReport = createAsyncThunk(
  "scoutingReports/updateReport",
  async ({ id, data, token }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/scouting-reports/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateReportAll = createAsyncThunk(
  "scoutingReports/updateReportAll",
  async ({ ids, token }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/scouting-reports/verify/all`,
        { ids },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchMyGuysReports = createAsyncThunk(
  "scoutingReports/myGuysReports",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/scouting-reports/my/guys`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
